import { APP_INSTALLER_SCOPE } from '@wix/app-installer-fed-serverless/dist/consts';
import Experiments from '@wix/wix-experiments';
let installerExperiments;
export const loadExperiments = async errors => {
  if (!installerExperiments) {
    installerExperiments = new Experiments();
  }
  await installerExperiments.load(APP_INSTALLER_SCOPE).catch(e => errors.push(e));
};
export const getExperiments = () => {
  if (!installerExperiments) {
    throw new Error('Experiments are not loaded');
  }
  return installerExperiments;
};
//# sourceMappingURL=experiments.js.map